<div #dropdown class="custom-dropdown" id="dropdown">
    <div class="dropdown-select" (click)="toggleDropdown()">{{ placeholder == 'new' ? 'New Team' : placeholder }}</div>
    <div class="dropdown-content">
        <ul>
            <li (click)="newTeam()">
                <div class="custom-item-with-leading">
                    <div class="rounded-avatar flex items-center justify-center icon-box">
                        <mat-icon aria-label="new team icon">add</mat-icon>
                    </div>
                    <h5 class="custom-item-title">New Team</h5>
                </div>
            </li>
            <!-- <li *ngIf="!isLoggedIn" (click)="needTeams()">
                <div class="custom-item-with-leading">
                    <div class="rounded-avatar flex items-center justify-center icon-box">
                        <mat-icon aria-label="my teams icon">groups</mat-icon>
                    </div>
                    <h5 class="custom-item-title">My Teams</h5>
                </div>
            </li> -->
            <li *ngFor="let item of items" (click)="onItemClick(item)">
                <div class="custom-item-with-leading">
                    <img [src]="item.team_image" alt="team_image" width="50px" class="rounded-avatar">
                    <h5 class="custom-item-title"><span *ngIf="item.in_game">(In Game) </span><span>#{{item.kt_team_id}} {{ item[optionKeyForLabel] }} </span></h5>
                </div>
            </li>
        </ul>
    </div>
</div>